import api from './api';

export const sendImportFile = async (channelId, file) => {
	const config = { headers: { 'content-type': 'multipart/form-data' } };
	return api.post(`/admin/channel/${channelId}/importsFromExternal`, file)
}